import { persist } from 'zustand/middleware';
import { createWithEqualityFn as create } from 'zustand/traditional';

interface CampaignIdCacheEntry {
  campaignId: string;
  campaignSlug: string;
}
interface CampaignIdCache {
  campaignIdCache: {
    [campaignSlug: string]: CampaignIdCacheEntry;
  };
  setCampaignIdCache: (newEntry: CampaignIdCacheEntry) => void;
}

const useCampaignIdCache = create<CampaignIdCache>()(
  persist(
    (set, get) => ({
      campaignIdCache: {},

      setCampaignIdCache: (newEntry: CampaignIdCacheEntry) => {
        set({
          campaignIdCache: {
            ...get().campaignIdCache,
            [newEntry.campaignSlug]: {
              campaignId: newEntry.campaignId,
              campaignSlug: newEntry.campaignSlug,
            },
          },
        });
      },
    }),
    {
      name: 'live-display-campaign-id-cache',
    },
  ),
);

export type { CampaignIdCache };
export { useCampaignIdCache };
